import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { PayIdRequestDTO, PaymentResponseDTO, RazorpayCreateOrderDTO, RazorpayOrderItem } from "./razorpay.interface";
import { Observable } from "rxjs";
import { RazorPay_CreateOrder, RazorPay_Pay_Id } from "src/app/GlobalVariable";

@Injectable({ providedIn: 'root' })
export class RazorpayServices {
    private http = inject(HttpClient);

    //Create Order
    Razorpay_CreateOrder(data: RazorpayCreateOrderDTO): Observable<RazorpayOrderItem> {
        return this.http.post<RazorpayOrderItem>(RazorPay_CreateOrder, data)
    }
    //Pay_Id
    Razorpay_PayId_Create(data: PayIdRequestDTO): Observable<PaymentResponseDTO> {
        return this.http.post<PaymentResponseDTO>(RazorPay_Pay_Id, data)
    }


    /**
     * Creates an order in the payment system.
     *
     * @param amount     Amount to be Paid
     * @param receiptNo  Unique receipt number for tracking
     * @param notes      Optional notes attached to the order
     * @param currency   Currency code (default: INR)
     *
     * @example
     * createOrder(500, 'RCPT_001', { note1: 'Test', note2: 'Order #1' });
    */
    InitializeOrder(
        amount: number,
        receiptNo: string,
        notes: { note1: string; note2: string } = { note1: '', note2: '' },
        currency: string = 'INR'
    ) {
        const data: RazorpayCreateOrderDTO = {
            amount,
            currency,
            receipt: receiptNo,
            notes: {
                notes_key_1: notes.note1,
                notes_key_2: notes.note2
            }
        }

        this.Razorpay_CreateOrder(data).subscribe({
            next: (res: RazorpayOrderItem) => {
                
            }
        })
        
    }

}